import vbAttachmentTokenService from "./vbAttachmentTokenService";
import buildAttachmentURL from "../filters/buildAttachmentURL";
import constants from "../constants";

export default {
  downloadFileCommon(getTokenPromise, url) {
    return getTokenPromise.then(vbAttachmentToken => {
      // console.log(buildAttachmentURL(vbAttachmentToken.token, {downloadFileURL: url}));
      window.open(
        buildAttachmentURL(vbAttachmentToken.token, {downloadFileURL: url}),
        "_blank"
      );
    });
  },

  downloadShareLibrary(vbAttachmentId) {
    return this.downloadFileCommon(
      vbAttachmentTokenService
        .getTokenForShareLibrary(vbAttachmentId)
        .then(response => response.data),
      constants.DOWNLOAD_FILE_URL.DOWNLOAD_FILE_SHARE_LIBRARY
    );
  },

  downloadReferenceOutgoingDoc_(docId) {
    return vbAttachmentTokenService
      .getTokenForReferenceOutgoingDoc(docId)
      .then(response => response.data);
  },

  downloadReferenceOutgoingDoc(docId) {
    return this.downloadFileCommon(
      this.downloadReferenceOutgoingDoc_(docId),
      constants.DOWNLOAD_FILE_URL.REFERENCE_OUTGOING_URL
    );
  },

  downloadReferenceOutgoingDocForVT(docId) {
    return this.downloadFileCommon(
      this.downloadReferenceOutgoingDoc_(docId),
      constants.DOWNLOAD_FILE_URL.REFERENCE_OUTGOING_URL_VT
    );
  },

  getTokenForDownloadOutgoingDocWithToken(docId, objectType) {
    return vbAttachmentTokenService
      .getTokenForOutgoingDocWithToken(docId, objectType)
      .then(response => response.data);
  },

  downloadOutgoingDocWithToken(docId, objectType) {
    return this.downloadFileCommon(
      this.getTokenForDownloadOutgoingDocWithToken(docId, objectType),
      constants.DOWNLOAD_FILE_URL.OUTGOING_WITH_TOKEN_URL
    );
  },

  downloadOutgoingDocWithTokenVT(docId, objectType) {
    return this.downloadFileCommon(
      this.getTokenForDownloadOutgoingDocWithToken(docId, objectType),
      constants.DOWNLOAD_FILE_URL.OUTGOING_WITH_TOKEN_URL_VT
    );
  },

  downloadOutgoingDoc_(docId) {
    return vbAttachmentTokenService
      .getTokenForOutgoingDoc(docId)
      .then(response => response.data);
  },

  downloadOutgoingDoc(docId) {
    return this.downloadFileCommon(
      this.downloadOutgoingDoc_(docId),
      constants.DOWNLOAD_FILE_URL.OUTGOING_URL
    );
  },

  downloadOutgoingDocVT(docId) {
    return this.downloadFileCommon(
      this.downloadOutgoingDoc_(docId),
      constants.DOWNLOAD_FILE_URL.OUTGOING_URL_VT
    );
  },

  downloadHcCaseCalendarAttachment(hcCaseCalendarId, vbAttachmentId) {
    return this.downloadFileCommon(
      vbAttachmentTokenService
        .getTokenForHcCaseCalendarAttachment(hcCaseCalendarId, vbAttachmentId)
        .then(response => response.data),
      constants.DOWNLOAD_FILE_URL.DOWNLOAD_FILE_COMMON
    );
  },

  downloadFileIncomingDoc(docId) {
    return vbAttachmentTokenService
      .getTokenForIncomingDoc(docId)
      .then(response => {
        let vbAttachmentToken = response.data;
        let url = buildAttachmentURL(vbAttachmentToken.token, {
          downloadFileURL:
          constants.DOWNLOAD_FILE_URL.DOWNLOAD_FILE_INCOMING_DOC
        });
        window.open(url, "_blank");
      });
  },

  downloadDocRelateWithTask(taskId, docId) {
    return vbAttachmentTokenService
      .getTokenForDocRelateWithTask(taskId, docId)
      .then(response => {
        let vbAttachmentToken = response.data;
        let url = buildAttachmentURL(vbAttachmentToken.token, {
          downloadFileURL:
          constants.DOWNLOAD_FILE_URL.DOWNLOAD_FILE_DOC_RELATE_TASK
        });
        window.open(url, "_blank");
      });
  },

  downloadFileForHcCommandsDocRelation(
    objectId,
    objectType,
    referenceObjectType,
    referenceObjectId
  ) {
    return vbAttachmentTokenService
      .getTokenForHcCommandsDocRelation(
        objectId,
        objectType,
        referenceObjectType,
        referenceObjectId
      )
      .then(response => {
        let vbAttachmentToken = response.data;
        let url = buildAttachmentURL(vbAttachmentToken.token, {
          downloadFileURL:
          constants.DOWNLOAD_FILE_URL.DOWNLOAD_HC_COMMANDS_DOC_RELATION,
          referenceObjectType: referenceObjectType
        });
        window.open(url, "_blank");
      });
  },

  downloadFileForHcCaseFlightFile(
    hcCaseFlightId,
    hcCaseFlightFileId,
    vbAttachmentId
  ) {
    return vbAttachmentTokenService
      .getTokenForHcCaseFlightFile(
        hcCaseFlightId,
        hcCaseFlightFileId,
        vbAttachmentId
      )
      .then(response => {
        let vbAttachmentToken = response.data;
        let url = buildAttachmentURL(vbAttachmentToken.token, {
          downloadFileURL: constants.DOWNLOAD_FILE_URL.DOWNLOAD_FILE_COMMON
        });
        window.open(url, "_blank");
      });
  },

  downloadFileForTaskAttachment(tkTaskId, attachmentId) {
    return vbAttachmentTokenService
      .getTokenForTaskAttachment(tkTaskId, attachmentId)
      .then(response => {
        let vbAttachmentToken = response.data;
        let url = buildAttachmentURL(vbAttachmentToken.token, {
          downloadFileURL: constants.DOWNLOAD_FILE_URL.DOWNLOAD_FILE_COMMON
        });
        console.log(url);
        window.open(url, "_blank");
      });
  },

  downloadFileForAttachmentComment(attachmentId) {
    return vbAttachmentTokenService
      .getTokenAttachmentComment(attachmentId)
      .then(response => {
        let vbAttachmentToken = response.data;
        let url = buildAttachmentURL(vbAttachmentToken.token, {
          downloadFileURL: constants.DOWNLOAD_FILE_URL.DOWNLOAD_FILE_COMMON
        });
        window.open(url, "_blank");
      });
  }
};



// WEBPACK FOOTER //
// ./src/services/downloadService.js